import React, { useState, useEffect } from 'react'
import Header from '../components/Header'
import wifi from '../assets/Group-19574.svg'
import play from '../assets/246462018fb1fdde4d60e0869a01238d.svg'
import message from '../assets/Group-19575.svg'
import Mockup from '../components/Mockup'
import Banner_2 from '../assets/homepage-web-view-1536x864.png'
import bike from '../assets/Group.png'
import Footer from '../components/Footer'

import controller from '../assets/controller.svg'
import controller2 from '../assets/controller2.svg'

import { Check, CreditCard, Download } from 'lucide-react';

import Slider from "react-slick";
import { LazyLoadImage } from 'react-lazy-load-image-component';


import StarWars from './starwars.mp4';
import TomAndJerry from './tomandjerry.mp4';
import MrBeen from './mrbean.mp4';

import { useIsMobile } from '../helpers/IsMobile'

import data from '../Games.json'

export default function Home() {

  useEffect(() => {
    if (window.AOS) {
      window.AOS.init({ duration: 500 });
    }
  }, []);


  const games = [
    {
      title: "Star Wars Rebels - Special Ops",
      category: "Star Wars",
      description: "Enjoy the exciting game Star Wars Rebels - Special Ops!",
      video: StarWars,
      image: "https://gamesbox.s3.eu-central-1.amazonaws.com/Star+Wars/Star+Wars+Rebels+-+Special+Ops/screenshot.jpg"
    },
    {
      title: "Tom and Jerry - What's the Catch",
      category: "Tom And Jerry",
      description: "Get on your surfboard, grab a bow and destroy the evil skeletons before they kill you!",
      video: TomAndJerry,
      image: "https://gamesbox.s3.eu-central-1.amazonaws.com/Tom+and+Jerry/Tom+and+Jerry+-+What's+the+Catch/screenshot.jpg"
    },
    {
      title: "Mr. Bean - Goldfish Loopy Loopy",
      category: "Mr. Bean",
      description: "Enjoy the exciting game Mr. Bean - Goldfish Loopy Loopy!",
      video: MrBeen,
      image: "https://gamesbox.s3.eu-central-1.amazonaws.com/Mr.+Bean/Mr.+Bean+-+Goldfish+Loopy+Loopy/screenshot.jpg"
    }
  ];


  const [activeCategory, setActiveCategory] = useState(data[0]?.Name || '');


  const isMobile = useIsMobile();

  var settings = {
    dots: false,
    infinite: false,
    arrows: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 3,
    initialSlide: 0,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          arrows: true,

          slidesToScroll: 3

        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 4,
          arrows: true,

          slidesToScroll: 3

        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          arrows: false,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          arrows: false,
          slidesToScroll: 1
        }
      }
    ]
  };




  return (
    <div>
      <Header />
      <section >
        <div className='video_banner'  >


          <video
            className="d-block"
            autoPlay
            muted
            loop
            playsInline
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          >
            <source src='/Video-Games-Box.mp4' type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <div className='video_banner_inner' >

            <div className='container' >

              <h1 >ENDLESS PLAY <span className='hero-text' >Starts</span> <br></br>  <span className='hero-text' >Here</span> </h1>
              <p>Discover more than 500+ games with Gaming Pro Premium!</p>
              {/* <p className='bold' >15$ / month</p> */}
              {/* <div className='d-flex flex-row gap-2 ' >
                <a className='btn btn-primary' href='#DownloadSection'>Download Our App <Download size={23} /></a>


                <a className='btn btn-primary' href='https://publisherads.click/?SMCampaign=4b76ea47-f7f4-4557-8548-181e76406142&ClickID=YOUR_CLICK_ID&Pub_ID=YOUR_PUB_ID&Aff_ID=YOUR_AFF_ID&extra=YOUR_Dynamic_Parameter_IF_Needed&extra1=YOUR_Dynamic_Parameter_IF_Needed&utm_source=affiliate&utm_medium=cpc&utm_campaign={campaignid}&utm_content={adgroupid}&utm_term={keyword}&country=null&themeid=3&portal=GamesBox'
                  target='_blank' >Subscribe Now     <CreditCard size={23} /></a>
              </div> */}
            </div>

          </div>
        </div>
      </section>


      <div className="pt-5">
 <div className="container ma-container">
 <div className="row">
 <div className="col">

        {/* Nav Pills Carousel New*/}
        <Slider {...settings}>
          {data.map((category, index) => (

            <ul className="nav nav-pills flex-nowrap">
              <li className="nav-item me-2 d-flex flex-row" key={index}>
                <button
                  className={`nav-link ${activeCategory === category.Name ? 'active-link' : ''}`}
                  onClick={() => setActiveCategory(category.Name)}
                >
                  {category.Name}
                </button>


                <button
                  className={`nav-link `} >
                  |
                </button>


              </li>

            </ul>
          ))}
        </Slider>

        <br></br>
        <br></br>
             <Slider
          {...{
            dots: false,
            arrows: false,
            infinite: false,
            speed: 500,
            slidesToShow: 6.5,
            responsive: [
              { breakpoint: 1200, settings: { slidesToShow: 5.5 } },
              { breakpoint: 992, settings: { slidesToShow: 4.5 } },
              { breakpoint: 768, settings: { slidesToShow: 3.5 } }
            ]
          }}
        >
          {data
            .find((category) => category.Name === activeCategory)
            ?.Content.map((game, index) => (
              <div key={index} className="px-2">
                <div
                  className="w-100"
                  style={{
                    aspectRatio: '1 / 1',
                    borderRadius: '15px',
                    overflow: 'hidden',
                  }}
                >
                  <LazyLoadImage
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '10px',
                      filter: 'brightness(0.8)',
                    }}
                    alt={game.Title}
                    src={game.Thumbnail_Large}
                    effect="blur"
                    wrapperProps={{
                      style: { transitionDelay: '1s' },
                    }}
                  />
                </div>
              </div>
            ))}
        </Slider>
</div>
</div>
</div>
   

      </div>




      {/* <section className='my-7'>
        <div className='container text-center' data-aos="zoom-in">
          <h1>Game Library Paradise</h1>
          <h1>Discover Countless Games</h1>
          <p className='my-4' >Hundreds Of Games, Endless Fun! Can't Decide Between Honing Your Skills, A
            Thrilling Match-3 Battle, Or A <br></br> Relaxing Puzzle? We've
            Got You Covered. With Over 500 Games For All Ages,
            Spanning Action, Arcade Classics, <br></br> Sports, Racing, Jumping
            Adventures, And More, Gaming Pro Premium Is Your One-Stop Shop For All Things Gaming.          </p>
        </div>

        <img data-aos="zoom-in" alt="html5 games" src={Banner_2} width={'100%'} style={{ height: '100vh', objectFit: 'cover' }} />
      </section> */}


      <section className='gradient-bg'>
        <div className='container my-7 py-5' >
          <div className='row'>
            <div className='col-lg-6 mt-3' >

              <div data-aos="zoom-in" className='d-flex flex-column justify-content-center align-items-start' style={{ height: '100%' }}>
                <h2 className='bold mb-4' >Level Up Your Play <br></br>With <span className='text-filled' >Top Features</span></h2>

                <div className='d-flex flex-column gap-3 mb-3' >
                  <div className='iconbox' > <Check /> <p>Unlimited Access To More Than 500 Games</p></div>
                  <div className='iconbox' > <Check /> <p>No Need to install games</p></div>
                  <div className='iconbox' > <Check /> <p>Find Fast With Categories & Collections</p></div>
                  <div className='iconbox' > <Check /> <p>Search Easy For Quick Discovery</p></div>
                  <div className='iconbox' > <Check /> <p>Play Your Way With Multilingual Support</p></div>
                  <div className='iconbox' > <Check /> <p>Add To Favorites For Easy Access</p></div>
                </div>

              </div>

            </div>

            <div className='col-lg-6' >
              <img data-aos="zoom-out" src={bike}
                width={'90%'} style={{ margin: 'auto' }} alt="motorcycle games" />
            </div>

          </div>
        </div>
      </section>


      <section data-aos="zoom-in" className='container' style={{ position: 'relative' }}>

        <img src={controller} className='controller1' />
        <img src={controller2} className='controller2' />

        <h2 className='text-center' style={{ paddingTop: '7rem' }} >Unbox  <span className='text-filled' >Your Questions</span> </h2>
        <hr className='my-4'></hr>

        <div className="accordion" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
                What is Gaming Pro Premium?
              </button>
            </h2>

            <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
              <div className="accordion-body">
                Imagine having an entire arcade at your fingertips, with hundreds of games waiting to be explored! That’s Gaming Pro Premium. We’re a subscription service with a library of over 500 games across all your favorite genres. Plus, finding your next favorite is easy with categorized collections and a fast search bar. Play in your language, create a “Favorites” list, and get ready for endless fun!
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo">
                What Games Can I Play With My Subscription?
              </button>
            </h2>
            <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div className="accordion-body">
                With your Gaming Pro Premium subscription, you have access to our entire library of over 500 diverse games! Action, puzzle, racing – you name it, we have it!
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree">
                Do I Need To Download The Games?
              </button>
            </h2>
            <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div className="accordion-body">
                No. Skip the download, start the fun: Gaming Pro Premium streams games directly to your device, so you can play instantly without downloads or installations.
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour">
                What Happens To My Favorites?
              </button>
            </h2>
            <div id="collapseFour" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div className="accordion-body">
                When you add a game to your “Favorites” list in Gaming Pro Premium, it’s stored in your account. This way, you can easily access your favorite titles anytime, across any device you use with Gaming Pro Premium.
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive">
                How Do I Cancel?
              </button>
            </h2>
            <div id="collapseFive" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div className="accordion-body">
                You can easily cancel your Gaming Pro Premium subscription at any time directly through your account settings.
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix">
                Is There An Age Restriction For Gaming Pro Premium?
              </button>
            </h2>
            <div id="collapseSix" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div className="accordion-body">
                Gaming Pro Premium is friendly for all ages, with a focus on fun for everyone!
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven">
                What Devices Are Compatible With Gaming Pro Premium?
              </button>
            </h2>
            <div id="collapseSeven" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div className="accordion-body">
                You can enjoy your favorite games on your computer, smartphone, or tablet.
              </div>
            </div>
          </div>
        </div>

      </section>

      <Footer />

    </div >
  )
}
